/** The supported text-based channels. */
export const textualChannels = [
  'contact_form',
  'email',
  'facebook_messenger',
  'messenger',
  'sms',
  'twitter',
  'whats_app',
  'widget_chat',
  'adachat',
  'digitalgeniuschat',
  'kindlychat',
  'genericapimessaging',
  'trustpilotreviews',
  'yotporeviews',
] as const;

/** The supported phone-based channels. */
export const telephonyChannels = [
  'callback',
  'pstn_phone',
  'voicemail',
] as const;

/** The supported conversation channels. */
export const channels = [...textualChannels, ...telephonyChannels] as const;

/** The supported media. */
export const media = [
  'email',
  'interactivechat',
  'messaging',
  'speak',
] as const;
